<!-- start header  -->
<header>
    <app-head (newItemEvent)="addItem($event)" [titleModule]="'Issue Reports'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0">

    <!-- start sidebar  -->
    <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'Issue_Reports'"></app-sidebar>
    <!-- end sidebar  -->

    <!-- start content page  -->
    <main class="p-4 col-lg-10">
        <div class="d-md-flex justify-content-between dashboard" style="margin-top: 8px; margin-bottom: 16px;">
            <p class="fw-bold" style="color: #6c6a6a;">Issue Reports</p>
            <div class="d-flex justify-content-lg-between ">
              <!-- <app-dropdown class="ms-3" [list]="listDropDown" (selected)="selectedfromDropDown($event)"></app-dropdown> -->

            <app-dropdown class="me-3" [list]="listDropDown" (selected)="selectedfromDropDown($event)"></app-dropdown>
           <div class="d-flex mb-2  ">
                <button class="week rounded-start px-3 py-2 bg-w outline-none" (click)="FilterButtons('This Month')" [ngClass]="{'activeButton': monthButton == true}">This Month</button>
                <button class="week px-3 py-2 outline-none rounded-end" (click)="FilterButtons('Last Week')" [ngClass]="{'activeButton': weekButton == true}">Last Week</button>
            </div></div>
        </div>

        <p-toast></p-toast>
<!------------------------------------------------------------------------------------->
        <!-- <div class="card">
            <div class="row d-block d-md-flex justify-content-between align-items-center my-2 px-3 py-3">

                <div class="col-md-4">
                  <div class="d-flex align-items-center" style="font-size: 15px;">
                    <label for="" style="color: #313331;font-weight: 500;font-size: 16px;">Issue</label>
                    <img src="assets/images/line.svg" class="mx-3" >
                    <select class="form-select" (change)="clickIquires($event)">
                      <option *ngFor="let data of InquireFillterLists; let index=index;" [value]="data.id" [selected]="InquireFillterSelected[index]">{{data.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-5 col-8">
                  <div class="input">
                    <input type="text" class="form-control py-2 w-100" placeholder="Search Issues" (keyup)="searchAction($event)" [(ngModel)]="searchText" />
                      <img src="../../../assets/images/search.svg" alt="">
                  </div>
              </div>
 
            </div>
           



            <p-table class="table-shopping " [selectionPageOnly]="true" [tableStyle]="{'min-width': '50rem' ,'min-': '50rem'}" [value]="issues">

                <ng-template pTemplate="header" class="text-center">
                    <tr *ngIf="headerData">
                        <ng-container>


                            <th class="td-name">
                                Report ID

                            </th>
                            <th class="td-name">
                                Requested by

                            </th>
                            <th class="td-name">
                                Apartment Number

                            </th>
                            <th pSortableColumn="date_Reported" class="td-name">
                                Date Reported <p-sortIcon field="date_Reported"></p-sortIcon>
                      

                            </th>
                            <th class="td-name">
                                Descriptions

                            </th>
                            <th pSortableColumn="issue_Status" class="td-name">
                                Status <p-sortIcon field="issue_Status"></p-sortIcon>
                   

                            </th>
                            <th class="td-name">

                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-issue style="height: 200px !important;">

                    <tr style="cursor: pointer;" (click)="hidecard()" >


                        <td class="d-flex align-items-center" routerLink="/Issue_Reports/Report-view/{{issue.issue_ID}}">
                            {{issue?.issue_Code}}
                        </td>
                        <td routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
                          {{issue?.requsted_By }}

                        </td>

                        <td routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
                            {{issue?.apartment_Number}}
                        </td>

                        <td  routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
                            {{issue?.date_Reported | date:'medium' }}
                        </td>
                        <td routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
                          <p style="width: 10vw; overflow: hidden; text-overflow: ellipsis;
                          white-space: nowrap;"> {{issue?.desc}}
                          </p>
                        </td>
                        <td class="text-center" routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
                          <div>
                              <span class="rounded-5 px-3 badge Pending" *ngIf="issue?.issue_Status=='Pending'">
                                {{issue?.issue_Status}}
                                <span>
                                  <img src="assets/images/purbleArrow.svg" alt="">
                                </span>
                            </span>
                            <span class="rounded-5 px-3 badge Cancelled" *ngIf="issue?.issue_Status=='Cancelled'">
                              {{issue?.issue_Status}}
                              <span>
                                <img src="assets/images/redDot.svg" alt="">
                              </span>
                          </span>
                          <span class="rounded-5 px-3 badge Completed"  *ngIf="issue?.issue_Status=='Completed'">
                            {{issue?.issue_Status}}
                            <span>
                              <img src="assets/images/greenArrow.svg" alt="">
                            </span>
                        </span>
                      <span class="rounded-5 px-3  badge InProgress"  *ngIf="issue?.issue_Status=='InProgress'">
                        {{issue?.issue_Status}}
                        <span>
                          <img src="assets/images/blueArrow.svg" alt="">
                        </span>
                    </span>
                          </div>
                      </td>


                        <td class="cursor position-relative" style="text-align: center;">
                            <button class="border-0 outlin-0 bg-transparent" (click)="detailperson($event,issue?.issue_ID)">
              <img src="assets/images/edit.svg">
          </button>
                            <div *ngIf="showEdit[issue.issue_ID] " class="Actions position-absolute z-3 rounded-3 bg-white border edit-button">
                                <button class="d-block border-0 outlin-0 bg-transparent my-2 button text-start py-2 w-100" routerLink="/Issue_Reports/Report-view/{{issue.issue_ID}}">View Details</button>

                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2" routerLink="/Issue_Reports/assgin-issue/{{issue.issue_ID}}"> assign worker  </button>
                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2" routerLink="/Issue_Reports/assgin-issue-owner/{{issue.issue_ID}}"> assign owner  </button>

                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2" (click)="OpenModal1(issue?.issue_ID) " *ngIf="issue.worker!='00000000-0000-0000-0000-000000000000'">Mark it as In-Progress


                                </button>
                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2" (click)="OpenModal2(issue?.issue_ID)">Mark it as Solved

                                   </button>
                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2" (click)="OpenModal3(issue?.issue_ID)">New Appointment

                                   </button>
                                <button *ngIf="issue?.issue_Status !='Cancelled'" class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2" (click)="cancelissue(issue?.issue_ID)">Cancel </button>

                            </div>

                        </td>

                    </tr>

                </ng-template>


                <ng-template pTemplate="emptymessage">
                    <div class="container text-center mt-4">
                        <p class="mb-0">No data found.</p>
                    </div>
                </ng-template>


            </p-table>
            <p-paginator *ngIf="issues.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
              [totalRecords]="totalRecords" [first]="first"></p-paginator>


        </div> -->
<!----------------------------------------update--------------------------------------------->



      <!-----------------------------------------------------------update----------------------------------------------------------------------------->
      <div>
        <div class="p-card p-3" style="border-radius: 16px;" >
          <div class="flex justify-content-between align-items-center mb-4" style="display: flex;">
            <!-- <h2>Subscription Alerts</h2> -->
             <!-- <div class="card-header">Users <span> {{numberTenants}} Users</span></div> -->
             <div class="d-flex mx-2 mt-4">
              <p class="me-2 fs-5 fw-bold ml-8">Issues</p>
              <p class="mb-3 bg-gray rounded-5 blue px-2 d-flex align-items-center">
                  {{totalRecords}} Issues
              </p>
          </div>
            <div class="p-inputgroup w-50" style=" position: relative;">
              <!-- <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
              </span> -->
              <input type="text"  class="search-input" pInputText placeholder="      Search any Keywords" [(ngModel)]="globalFilter" (input)="dt2.filterGlobal(globalFilter, 'contains')" />
              <i class="pi pi-search search-icon"></i>
              <!-- <button pButton icon="pi pi-filter" class="p-button-outlined"></button> -->
               <!-- <img src="filterplan.svg" (click)="openFilterDialog()"   style="margin-left: 24px; cursor: pointer;"/> -->
            </div>
          </div>
        <!--[paginator]="true"  [rowsPerPageOptions]="[10, 25, 50]"  [rows]="5"-->
        <p-table
        #dt2
        [value]="issues"
        dataKey="issue_ID"


        *ngIf="tableReady"
        [paginator]="true" 
        [rows]="10"

       
        [first]="issues.length > 0 ? currentPage : 0"
        (onPage)="onPageChange($event)"
           
        [rowsPerPageOptions]="[10, 20, 50]"
       
        
        
        
        [globalFilterFields]="['issue_Code',  'requsted_By', 'apartment_Number','date_Reported','desc','issue_Status'  ]"
        [tableStyle]="{ 'min-width': '75rem' }"

        [customSort]="true"
        (sortFunction)="customSort($event)"
    >
        <ng-template pTemplate="caption">
            <!-- <div class="flex">
                <p-iconField iconPosition="left" class="ml-auto">
                    <p-inputIcon>
                        <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input 
                        pInputText 
                        type="text" 
                        (input)="dt2.filterGlobal(globalFilter, 'contains')"
                        placeholder="Search keyword" />
                </p-iconField>
            </div> -->
        </ng-template>
        <ng-template pTemplate="header">
            <tr class="headOne">
                <!-- <th style="width:22%">booking ID</th> -->
                <th style="width:22%">Report ID</th>
                <th style="width:22%"> Requested by</th>
                <th style="width:22%">Apartment Number</th>
                <th pSortableColumn="date_Reported" style="width:22%">
                  Date Reported <p-sortIcon field="date_Reported"></p-sortIcon>
              </th>
                <th style="width:22%">Descriptions</th> 
                <th style="width:22%">Status</th> 
                
                <th style="width:6%">Action</th>

            </tr>
            <tr>
                <th style="width:22%">
                    <p-columnFilter 
                        type="text" 
                        field="issue_Code" 
                        placeholder="Search by Code" 
                        ariaLabel="Filter Code" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text" 
                        field="requsted_By" 
                        placeholder="Search by Name" 
                        ariaLabel="Filter Name" />
                </th>
                
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="apartment_Number" 
                  placeholder="Search by apartment" 
                  ariaLabel="Filter apartment" />
                </th>

                <th>
                  <p-columnFilter 
                    type="date" 
                    field="date_Reported" 
                    display="menu"
                    placeholder="Search by date" 
                    ariaLabel="Filter by date"
                    [showOperator]="false"
                    [showAddButton]="false"
                    dateFormat="yy-mm-dd">
                  </p-columnFilter>
                </th>
                

                <th>
                  <p-columnFilter 
                  type="text" 
                  field="desc" 
                  placeholder="Search by desc" 
                  ariaLabel="Filter desc" />
                </th>
               
                 
                
                  <th>
                    <p-columnFilter field="issue_Status" matchMode="equals" [showMenu]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown 
                          [ngModel]="value" 
                          [options]="statuses"
                          optionLabel="label" 
                          optionValue="value"
                          (onChange)="filter($event.value)"  
                          placeholder="Select One" 
                          [showClear]="true">
                          <ng-template let-option pTemplate="item">
                            <p-tag 
                              [value]="option.label" 
                              [severity]="getSeverity(option.label)">
                            </p-tag>
                          </ng-template>
                        </p-dropdown>
                      </ng-template>
                    </p-columnFilter>
                  </th>

                 
                  
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-issue>
          <tr style="cursor: pointer;"  >

            <td   routerLink="/Issue_Reports/Report-view/{{issue.issue_ID}}">
              {{issue?.issue_Code}}
          </td>
          <td routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
            {{issue?.requsted_By }}

          </td>

          <td routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
              {{issue?.apartment_Number}}
          </td>

          <td  routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
              {{issue?.date_Reported | date:'medium' }}
          </td>
          <td routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
            {{ issue?.desc?.length > 20 ? (issue.desc | slice:0:20) + '...' : issue.desc }}

          </td>
          <td class="text-center" routerLink="/Issue_Reports/Report-view/{{issue?.issue_ID}}">
            <div>
                <span class="rounded-5 px-3 badge Pending" *ngIf="issue?.issue_Status=='Pending'">
                  {{issue?.issue_Status}}
                  <span>
                    <img src="assets/images/purbleArrow.svg" alt="">
                  </span>
              </span>
              <span class="rounded-5 px-3 badge Cancelled" *ngIf="issue?.issue_Status=='Cancelled'">
                {{issue?.issue_Status}}
                <span>
                  <img src="assets/images/redDot.svg" alt="">
                </span>
            </span>
            <span class="rounded-5 px-3 badge Completed"  *ngIf="issue?.issue_Status=='Completed'">
              {{issue?.issue_Status}}
              <span>
                <img src="assets/images/greenArrow.svg" alt="">
              </span>
          </span>
        <span class="rounded-5 px-3  badge InProgress"  *ngIf="issue?.issue_Status=='InProgress'">
          {{issue?.issue_Status}}
          <span>
            <img src="assets/images/blueArrow.svg" alt="">
          </span>
      </span>
            </div>
        </td>

                <td  >
                


                    <!----------------------------->
                    <div   class="flex justify-content-start align-items-center gab-3" style="display: flex;">
                        <!-- <div><img class="mr-2" style="cursor: pointer;" src="alertUser.svg"/></div> -->
                        <div class=" ">
                          <img
                          routerLink="/Issue_Reports/Report-view/{{issue.issue_ID}}"
                            class="image-default"
                            src="assets/images/viewPay.svg"
                            alt="Default Alert Icon"
                            
                          />
                           
                        </div>
                        
                        
                        <div  >
                          <img class="mr-2" style="cursor: pointer;" src="assets/images/threeDotPay.svg" (click)="op.toggle($event)" />
                        </div>
                        <p-overlayPanel #op>
                          <ul   class="menu-list list-unstyled">
                            <li><a      style="cursor: pointer; Color:#363636; text-decoration: none;"  
                              routerLink="/Issue_Reports/assgin-issue/{{issue.issue_ID}}"> assign worker   </a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              routerLink="/Issue_Reports/assgin-issue-owner/{{issue.issue_ID}}"> assign owner</a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="OpenModal1(issue?.issue_ID) " *ngIf="issue.worker!='00000000-0000-0000-0000-000000000000'">Mark it as In-Progress</a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="OpenModal2(issue?.issue_ID)">Mark it as Solved</a></li>

                            <li><a  style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="OpenModal3(issue?.issue_ID)">New Appointmen</a></li>
                            <li style="cursor: pointer; Color:#363636; text-decoration: none;" (click)="cancelissue(issue?.issue_ID)">Cancel</li>
                          
                          </ul>
                        
                         
                        </p-overlayPanel>
                      </div>
                
                </td>
 

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No Data Found.</td>
            </tr>
        </ng-template>
</p-table>
<!-- 
	<p-paginator *ngIf="Inquires.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
							[totalRecords]="totalRecords" [first]="first"></p-paginator> -->

        </div>
        
      </div>
      <!---------------------------------------------------------------------------------------------------------------------------------------->

<!----------------------------------------------------------------------------------------------->

    </main>
</div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display1}" style=" background-color: rgb(23 22 22 / 50%);;">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="    margin-top: 150px;">
            <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;position: relative;">
                <p class="modal-title" style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                    <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
                    Mark it as In-Progress
              </span>
                </p>
                <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close" aria-label="Close" (click)="onCloseModal1()">
  <span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
</button>



            </div>

            <div class="modal-body">


                <div id="Bankdetails">
                    <!-- <p class="fw-bold mb-0"> Bank account information</p> -->
                    <p style="color: #605D62 !important;">Please Select an Appointment to go and solve this problem </p>
                </div>
                <!--start Other Details form-->

                <div class="row ">

                    <div class="col-12 col-md-9 mb-4 cardss" *ngFor="let item of appointement;let i=index">
                        <input type="radio" name="drone2" (change)="handleChange(item)">

                        <label class="fw-bold" style="color: #605D62; margin-left: 10px;">appointement ( {{i+1}} )
                          <br>
                          {{item.appo_Date}} {{item.appo_Time}} </label>
                    </div>
                </div>

            </div>




            <div class="modal-footer">

                <div class="d-flex justify-content-between">
                    <div class="py-2 px-3 fw-bold"></div>
                    <div class="d-flex justify-content-between">
                        <a (click)="onCloseModal1()" style="    border: 1px solid;" class="backcancel text-decoration-none cursor bg-white rounded-2 py-2 px-3 fw-bold mx-2 xcvdd">
                        Cancel
                          </a>
                        <button (click)="  MarkasProgress( )" class="rounded-2 text-white rounded-2 border-0 py-2 px-4" style="background-color: #1f4068 !important">
                        confirm
                        </button>
                    </div>
                </div>
                <!-- Confirm -->

            </div>


        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>


<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display3}" style=" background-color: rgb(23 22 22 / 50%);;">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="    margin-top: 150px;">
            <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;position: relative;">
                <p class="modal-title" style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                    <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
                  new appointment
            </span>
                </p>
                <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close" aria-label="Close" (click)="onCloseModal3()">
<span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
</button>



            </div>

            <div class="modal-body">


                <div id="Bankdetails">
                    <!-- <p class="fw-bold mb-0"> Bank account information</p> -->
                    <p style="color: #605D62 !important;">create new appointment to go and solve this problem </p>
                </div>
                <!--start Other Details form-->

                <div class="row ">

                    <div class="mb-3 col-12 col-md-12">
                        <label class="form-label gray fw-bold"> date</label>
                        <!-- <p-calendar [(ngModel)]="Apointment3"></p-calendar> -->
                        <p-calendar [(ngModel)]="Apointment3" [showTime]="true" dateFormat="dd/mm/yy" [showSeconds]="true"></p-calendar>

                    </div>

                </div>

            </div>




            <div class="modal-footer">

                <div class="d-flex justify-content-between">
                    <div class="py-2 px-3 fw-bold"></div>
                    <div class="d-flex justify-content-between">
                        <a (click)="onCloseModal3()" style="    border: 1px solid;" class="backcancel text-decoration-none cursor bg-white rounded-2 py-2 px-3 fw-bold mx-2 xcvdd">
                      Cancel
        </a>
                        <button (click)="  MarkasProgress2( )" class="rounded-2 text-white rounded-2 border-0 py-2 px-4" style="background-color: #1f4068 !important">
                      confirm
        </button>
                    </div>
                </div>
                <!-- Confirm -->

            </div>


        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display2}" style=" background-color: rgb(23 22 22 / 50%);;">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="    margin-top: 150px;">
            <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;position: relative;">
                <p class="modal-title" style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                    <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
                      mark it as solved
            </span>
                </p>
                <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close" aria-label="Close" (click)="onCloseModal2()">
<span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
</button>



            </div>

            <div class="modal-body">


                <div class="row">

                    <div class="col-12 col-md-12 mb-4 cards">
                        <p style="color: #605D62 !important;margin-bottom: 0px;"> Who will Pay
                        </p>

                        <input type="radio" name="drone" checked (change)="handleChange2('StudiFlats')">

                        <label class="fw-bold" style="color: #605D62; margin-left: 10px;"> StudiFlats

                           </label>
                        <input type="radio" name="drone" (change)="handleChange2('Tenant')">

                        <label class="fw-bold" style="color: #605D62; margin-left: 10px;"> Tenant

                           </label>
                        <input type="radio" name="drone" (change)="handleChange2('Owner')">

                        <label class="fw-bold" style="color: #605D62; margin-left: 10px;"> Owner

                              </label>
                    </div>
                    <div class="mb-3 col-12 col-md-12">

                        <div  style="display: flex; justify-content: space-between; align-items: center;">
                            <div *ngIf="showDropdownTenant">
                                <div class="mb-2">
                                   <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Tenants payment options</label>
                               <p-dropdown
                               [options]="tenantOptions"
                               [(ngModel)]="selectedOption"
                               optionLabel="name"
                               placeholder="Please Select"
                               (onChange)="onOptionChange($event)" 
                               >
                               </p-dropdown>
                                </div>
                              </div>
       
                              <div *ngIf="showDropdownTenant&&!this.optionBoolean">
                               <label for="exampleInputPricepermonth" class="form-label gray fw-bold mb-0">Tenants</label>
       
                               <!-- <p-multiSelect 
                               [options]="guestOptions" 
                               [(ngModel)]="selectedGuests" 
                               optionLabel="guest_Name" 
                               placeholder="Select Guests"
                               (onChange)="onGuestsChange()">
                               </p-multiSelect> -->
                               <p-multiSelect
                                [options]="groupedGuests"
                                [group]="true"
                                [(ngModel)]="selectedGuests"
                                optionLabel="guest_Name"
                                placeholder="Select Guests"
                                scrollHeight="250px"
                                display="chip"
                                (onChange)="onGuestsChange()">
                                <ng-template let-group pTemplate="group">
                                    <div class="flex align-items-center">
                                    <span>{{ group.label }}</span>
                                    </div>
                                </ng-template>
                                </p-multiSelect>
                              </div>
                        </div>
                      
                     

 





                        <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Worker Cost</label>
                        <input type="number" [(ngModel)]="worker_cost" (keyup)="onSearchChange($event)" class="form-control rounded-2 py-2 fs-6" id="exampleInputPricepermonth" />

                    </div>
                    <div class="mb-3 col-12 col-md-12">
                        <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Item Cost</label>
                        <input type="number" [(ngModel)]="item_Cost" (keyup)="onSearchChange($event)" class="form-control rounded-2 py-2 fs-6" id="exampleInputPricepermonth" />

                    </div>

                    <div class="mb-3 col-12 col-md-12">
                      <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Service Cost</label>
                      <input type="number" [(ngModel)]="service_cost" (keyup)="onSearchChange($event)" class="form-control rounded-2 py-2 fs-6" id="exampleInputPricepermonth" />

                  </div>

                    <div class="mb-3 col-12 col-md-12">
                        <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Total Cost</label>
                        <input type="number" disabled="disabled" [(ngModel)]="Total_cost" class="form-control rounded-2 py-2 fs-6" id="exampleInputPricepermonth" />

                    </div>
                    <div class="mb-3 col-12 col-md-12">
                        <label for="exampleInputSecuritydeposit" class="form-label gray fw-bold">Description</label>
                        <textarea class="border p-3 pt-3 rounded-2 w-100" [(ngModel)]="discerption" rows="3" style="resize: inherit"></textarea>

                    </div>
                    <div class="mb-3 col-12 col-md-12">
                      <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Attachments</label>
                    <div class="image-upload mainimage">
                      <input type="file" accept="image/*,.pdf" multiple="multiple" (change)="onUploadContract($event,'contract_Path')">
                        <div class="image-uploads">
                          <div class="d-flex align-items-center justify-content-center text-center h-100" >
                            <div *ngIf="!selectedContractImg" class="text-center imageData pt-2" >
                              <div class="icon m-auto">
                                <img src="/assets/images/upload 1.svg" alt="img">
                               </div>
                               <p class="mb-0">Click to upload <span class="text-muted fw-normal"> or drag and drop</span></p>
                               <p class="text-muted fw-normal">PNG, JPG, PDF (max. 8MB)</p>
                            </div>
                            <ng-container *ngIf="selectedContractImg && (selectedContractImg.type == 'image/png' || selectedContractImg.type == 'image/jpg' || selectedContractImg.type == 'image/jpeg')">
                              <a (click)="opencloseModal(selectedContractImg.url)">
                              <img  *ngIf="selectedContractImg.url"  [src]="selectedContractImg.url" [alt]="selectedContractImg.name"  style="height: 124px;width:150px;">
                              </a>
                            </ng-container>

                            <ng-container *ngIf="selectedContractImg && selectedContractImg.type == 'application/pdf'">
                              <span>{{selectedContractImg.name}}</span>
                            </ng-container>
                          </div>
                        </div>
                    </div>

                  </div>
                </div>

            </div>




            <div class="modal-footer">

                    <div class="d-flex justify-content-between w-100">
                        <a (click)="onCloseModal2()" style="    border: 1px solid;" class="backcancel text-decoration-none cursor bg-white rounded-2 py-2 px-3 fw-bold  xcvdd">
                          Cancel
                        </a>
                        <button (click)="MarkAsSolved()" class="rounded-2 text-white rounded-2 border-0 py-2 px-4" style="background-color: #1f4068 !important">
                          confirm
                        </button>

                    </div>
                <!-- Confirm -->

            </div>


        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
